<!-- Drawer panel -->
<!-- NEVER FORGET TO ADD CLASS: [drawer-body] -->
<div class="drawer-body">
	<div class="card border-0">
		<div class="card-header bg-white py-sm-4 border-0 d-flex">
			<button class="btn btn-link btn-sm clear-all pl-0 pt-0" id="close-rsidebar" (click)="close()">
				<i class='bx bx-x bx-lg' style="font-size: 30px;"></i>
			</button>
			<h2 class="display-medium">Notifications</h2>
		</div>
		<ng-container *ngIf="!loading;else loader">
			<ng-container *ngIf="messages.length > 0 && !loading;else emptyNofications">
				<div class="row mx-3 mb-2">
					<button *ngIf="totalCount>0" class="btn btn-link btn-sm clear-all" data-toggle="tooltip"
						title="Mark all as read" (click)="clearAll()">
						Clear all
					</button>
					<button *ngIf="unreadCount>0" class="btn btn-link btn-sm mark-as-read" data-toggle="tooltip"
						title="Mark all as read" (click)="markAllAsRead()">
						Mark all as read
					</button>
				</div>
				<div class="pl-4 pr-3">
					<ng-container *ngFor="let message of messages; trackBy: trackByFn">
						<div class="d-flex m-bottom-imp-0 align-items-center my-3"
							[ngClass]="{'text-muted': (message.users.status == 'Read')}">
							<div class="flex-grow-1 pr-3">
								<ng-container *ngIf="message.navigate && message.navigate.type == 'Relative'">
									<a href="javascript:void" *ngIf="message.navigate.url" (click)="redirectTo(message)"
										class="text-dark text-decoration-none">
										<span>{{message.message }}</span>
									</a>
								</ng-container>
								<ng-container *ngIf="message.navigate && message.navigate.type == 'Absolute'">
									<a [href]="message.navigate.url" target="_blank" class="text-dark text-decoration-none">
										<span>{{message.message }}</span>
									</a>
								</ng-container>


								<div><small class="text-muted">{{message.createdAt|logTimeSpan}}</small></div>
							</div>

							<div class="flex-shrink-0">
								<button *ngIf="message.users.status==='Unread'" class="btn btn-link btn-sm" data-toggle="tooltip"
									title="Mark as read" (click)="markAsRead(message._id)">
									<i class='bx bxs-circle d-block'></i>
								</button>
							</div>
							<div class="flex-shrink-0">
								<button class="btn btn-sm" data-toggle="tooltip" title="Clear" (click)="clearNotification(message._id)">
									<i class='bx bx-x bx-fw'></i>
								</button>
							</div>
						</div>
					</ng-container>
				</div>
				<div class="row">
					<button *ngIf="messages.length<totalCount" class="btn btn-primary btn-sm mx-auto mt-2"
						(click)="loadMoreNotifications()">
						Load more
					</button>
				</div>
			</ng-container>
		</ng-container>
		<ng-template #emptyNofications>
			<div class="row">
				<div class="col-12">
					<p class="text-center text-muted">
						{{ loading ? 'Loading, please wait...' : 'No notifications right now'}}</p>
				</div>
			</div>
		</ng-template>
	</div>
</div>
<ng-template #loader>
    <div class="py-3 pl-4 pr-4">
        <app-loader [type]="'row'" [count]="5"></app-loader>
    </div>
</ng-template>
<div class="sidebar-backdrop d-block" (click)="close()"></div>